// extracted by mini-css-extract-plugin
module.exports = {"date":"index_date__39qSE","date-today":"index_date-today__3AfTu","events":"index_events__3mF80","list-event":"index_list-event__489SY","date-title":"index_date-title__E7Pcc"};